import React, { useState, useCallback, useEffect } from 'react'
import MasterPage from 'components/MasterPage'
import Pagination from 'react-js-pagination'
import { Card, Col, Row, Table, Form, Button, Modal } from 'react-bootstrap'
import { DashboardOutlined, EditOutlined, LinkOutlined } from '@material-ui/icons'
import { useDropzone } from 'react-dropzone'
import { api } from 'services'
import { Trans } from 'react-i18next'
import { DebounceInput } from 'react-debounce-input'
import './guide.css'

const Guide = () => {  
  const defaultFilters = { per_page: 10, page: 1 };

  const onDrop = useCallback(acceptedFiles => {
    setFile(acceptedFiles);
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  const [pagination, setPagination] = useState({});
  const [filters, setFilters] = useState(defaultFilters);
  const [data, setData] = useState([])
  const [show, setShow] = useState(false)
  const [name, setName] = useState("")
  const [file, setFile] = useState("")
  const [type, setType] = useState(null)
  const [url, setUrl] = useState("")
  const [currentId, setCurrentId] = useState(null)

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const handleToggleShow = () => {
    let _show;
    if (!show) _show = true;
    else {
      _show = false
      clearForm();
    }
    setShow(_show)
  }

  const clearForm = () => {
    setName("")
    setFile("")
    setType(null)
    setUrl("")
    setCurrentId(null)
  }

  useEffect(() => {
    getDocuments()
  }, [filters])

  const getDocuments = () => {
    let _filters = {...filters}
    api.get('documents', { params: _filters })
      .then((response) => {
        const { data, current_page, per_page, total, from, to } = response.data

        setPagination({
          current_page, per_page, total, from, to
        })
        setData(data.map(({ id, name, size, document_type, link, uri }) => {
          return {
            id, name, size, document_type,
            type: document_type == 1 ? 'Link' : 'Arquivo',
            _link: document_type == 1 ? link : uri
          }
        }))
      })
  }

  const buildModalFormFile = () => (
    <Modal size="lg" centered show={show} onHide={handleToggleShow}>
      <Modal.Header closeButton>
        <Modal.Title>{currentId? "Editar" : "Adicionar"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md="12" className="mb-3">
              <Form.Label>Link ou Arquivo:</Form.Label>
              <Form.Control
                as="select"
                disabled={!!currentId}
                value={type}
                onChange={({ target }) => setType(target.value)}
              >
                <option value={null} selected disabled>Selecione</option>
                <option value="1">Link</option>
                <option value="2">Arquivo</option>
              </Form.Control>
            </Col>
            {type == 1 ? (<>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Descrição:</Form.Label>
                  <Form.Control
                    onChange={({ target }) => setName(target.value)}
                    value={name}
                    as="input"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>URL:</Form.Label>
                  <Form.Control
                    type="url"
                    onChange={({ target }) => setUrl(target.value)}
                    value={url}
                    as="input"
                  />
                </Form.Group>
              </Col>
            </>) : type == 2 ? (<>
              <Col md={12}>
                <Form.Group className="file-input-document">
                  <Form.Label>Arquivo: {file[0] ? file[0].name : '...'}</Form.Label>
                  <div {...getRootProps()}>
                    <input
                      disabled={!!currentId}
                      {...getInputProps()}
                    />
                    {
                      isDragActive ?
                        <p>Solte o arquivo aqui...</p> :
                        <p>Arraste algum arquivo até aqui, ou click para selecionar o arquivo</p>
                    }
                  </div>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Nome:</Form.Label>
                  <Form.Control
                    onChange={({ target }) => setName(target.value)}
                    value={name}
                    as="input"
                  />
                </Form.Group>
              </Col>
            </>) : (<></>)} 
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleToggleShow}>
          Cancelar
        </Button>
        <Button variant="success" onClick={() => {
          let formData = new FormData()
          formData.append('name', name)
          formData.append('document_type', type)
          if (type == 1) {
            formData.append('link', url)
          } else if (type == 2 && !currentId) {
            formData.append('file', file[0])
          }

          let _path = "documents"

          if (currentId) {
            formData.append('_method', 'put')
            _path += "/"+currentId
          }

          api.post(_path, formData)
            .then(() => {
              getDocuments()
              handleToggleShow()
            })
        }}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  )

  return (<>
    <Card.Body className="shadow bg-white rounded mb-3">
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">
            Guias
          </h4>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <Form.Group>
            <Form.Label style={{ display: 'block' }}>&nbsp;</Form.Label>
            <Button 
              onClick={() => handleToggleShow()}
              className="login-btn mr-1" 
              variant="primary-login"
            >
              <i className="fas fa-plus"></i> Adicionar Guia
            </Button>
          </Form.Group>
        </Col>
      </Row>
      <Row className="justify-content-between">
        <Col xs="auto">
          <Form.Group>
            <Form.Label>Registros por página:</Form.Label>
            <Form.Control
              as="select"
              value={filters.per_page}
              onChange={({ target }) =>
                handleFilterChange({ per_page: target.value, page: 1 })
              }
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md="3">
          <Form.Group>
            <Form.Label>Buscar:</Form.Label>
            <DebounceInput
              element={Form.Control}
              debounceTimeout={500}
              value={filters.__search}
              onChange={({ target }) =>
                handleFilterChange({ __search: target.value, page: 1 })
              }
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Table 
            id="guide-table"
            bordered 
            striped
          >
            <thead>
              <th>#</th>
              <th>Nome/Descrição</th>
              <th>Tipo de Documento</th>
              <th className="action">Ações</th>
            </thead>
            <tbody>
              {data.map(file => (<>
                <tr>
                  <td>{file.id}</td>
                  <td>{file.name}</td>
                  <td>{file.type}</td>
                  <td className="action">
                    <a target="_blank" href={file._link} className="btn btn-success mr-2">
                      <LinkOutlined />
                    </a>
                    <a 
                      className="btn btn-info mr-2" 
                      onClick={() => {
                        handleToggleShow()
                        setCurrentId(file.id)
                        setName(file.name)
                        setType(file.document_type)
                        if (file.document_type == 1) {
                          setUrl(file._link)
                        }                        
                      }}
                    >
                      <EditOutlined />
                    </a>
                  </td>
                </tr>
              </>))}
            </tbody>
          </Table>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: pagination.from || '0' }} to{' '}
                {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
                records
              </Trans>
              <Col className="d-flex justify-content-end">
              <Pagination
                activePage={pagination.current_page}
                itemsCountPerPage={pagination.per_page}
                totalItemsCount={pagination.total}
                pageRangeDisplayed={5}
                onChange={page => handleFilterChange({ page })}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
    {buildModalFormFile()}
  </>)
}

export default MasterPage(Guide)